function SmallModal(props) {
  return (
    <div className="modal-casona">
      <h3>{props.title}</h3>
      {props.text ? <p>{props.text}</p> : ""}
      {props.body && typeof props.body === "function" && props.body()}
      {props.onCancelText ? (
        <button className="btn btc--alt" onClick={props.onCancel}>
          {props.onCancelText}
        </button>
      ) : null}

      <button className="btn" onClick={props.onConfirm}>
        {props.onConfirmText}
      </button>
    </div>
  );
}

export default SmallModal;
